module.exports = __webpack_public_path__ + "media/images/pic/brodno/online_lessons-ed4f6889867838d9f99ba313fab63407.png";